import Logo_S from "../../assets/images/Logo_S.png";
import Logo_A from "../../assets/images/Logo_A.png";
import AnimatedLetters from "../AnimatedLetters";
import "./index.scss";
import { useState } from "react";
import { useEffect } from "react";

const Home = () => {
    const [letterClass, setLetterClass] = useState("text-animate");
    const firstNameArray = Array.from("hubh");
    const lastNameArray = Array.from("shish.");

    useEffect(() => {
        setTimeout(() => {
            setLetterClass("text-animate-hover");
        }, 4000);
        return () => {
            console.log("This will be logged on unmount");
        };
    }, []);

    return (
        <div className="container home-page">
            <div className="text-zone">
                <h1>
                    <span className={letterClass}>H</span>
                    <span className={`${letterClass} _12`}>i,</span>
                    <br />
                    <span className={`${letterClass} _13`}>I</span>
                    <span className={`${letterClass} _14`}>'m</span>
                    <div className="name">
                        <img id="logo_s" src={Logo_S} alt="S" />
                        <AnimatedLetters
                            letterClass={letterClass}
                            strArray={firstNameArray}
                            idx={20}
                        />
                    </div>
                    <div className="name">
                        <img id="logo_a" src={Logo_A} alt="A" />
                        <AnimatedLetters
                            letterClass={letterClass}
                            strArray={lastNameArray}
                            idx={30}
                        />
                    </div>
                </h1>
                <h2>Software Development Enthusiast | Student</h2>
                <button>
                    <a
                        href="https://drive.google.com/file/d/1xsOnvUvA5RUg4UPcV4-H2QI9553nsHnV/view?usp=sharing"
                        rel="noreferrer"
                        target="_blank"
                    >
                        View Resume
                    </a>
                </button>
            </div>
        </div>
    );
};

export default Home;
